import React, {useEffect, useState} from 'react';
import {JsonApiClient} from "@drupal-api-client/json-api-client";
import Config from "../../utils/Config";
import {Jsona} from "jsona";

import Moment from 'react-moment';
import Box from "@mui/material/Box";
import {IAttendee, IAddress, IEvent, IPlace, ISchedule, IDateRange, IRichText} from "./Buxliest";
import AttendeesEventListItem from "./AttendeesEventListItem";
import EventScroller from "./EventScroller";


const client = new JsonApiClient(Config.getDrupalVar('path.baseRoot') + Config.getDrupalVar('path.baseUrl'), {
  serializer: new Jsona()
});

export interface IEventOverviewPerTimeProps {
  excludeDates: string[];
  registerSuccessCallback: () => void,
  title?: string
}

const EventOverviewPerTime = (props: IEventOverviewPerTimeProps) => {
  const [events, setEvents] = useState<IEvent[]>([]);
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [eventDates, setEventDates] = useState<string[]>([]);


  const addAttendeeSuccess = () => {
    props.registerSuccessCallback();
  }

  const getEvents = async () => {
    let filterEventDate = "&filter[event-date-filter][condition][path]=event_date.value" +
    "&filter[event-date-filter][condition][operator]=NOT%20IN";
    props.excludeDates.forEach((item, index) => {
      filterEventDate += "&filter[event-date-filter][condition][value]["+(index+1)+"]=" + encodeURIComponent(item)
    });
    let events = await client.getCollection("bux_event/bux_event", {
      queryString: "include=schedule,schedule.place,field_medium"
        + "&sort=event_date.value",
    }) as any;

    events = events.filter((event) => props.excludeDates.indexOf(event.event_date.value) < 0)
    console.log('events:', events);

    const eventDates = new Set<string>();
    events.forEach((item) => { eventDates.add(item.event_date.value)})
    console.log('eventDates:', eventDates);
    const eventDatesArray = [];
    eventDates.forEach((item) => {
      eventDatesArray.push(item);
    });
    setEventDates(eventDatesArray);

    setEvents(events);

    setSubmitting(false);
  };

  useEffect(() => {
    getEvents();
  }, [props.excludeDates]);

  return (
    <>
      {events?.length > 0 && (
        <>
          {props.title && (
            <div className="text-3xl font-semibold mt-8 mb-4">{props.title}
            </div>
          )}

          <div
            className="grid items-start grid-cols-1 md:grid-cols-1 ">
          {eventDates?.map((eventDate) =>
              <>
                <Box className="text-xl text-primary-500">
                  <Moment format="HH:mm U\hr" parse="YYYY-MM-DDTHH:mm:ss">
                    {eventDate}
                  </Moment>
                </Box>
                <EventScroller
                  events={events?.filter((item) => item.event_date.value == eventDate)}
                  registerSuccessCallback={addAttendeeSuccess}></EventScroller>

              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default EventOverviewPerTime;
